import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    voucher_appointments_subtitleDownload: 'Выходная форма ваучера',
    voucher_appointments_subtitle: 'Ваучеры',
    voucher_appointments_modalYes: 'Да',
    voucher_appointments_modalNo: 'Нет',
    voucher_appointments_requestFormId: '№ Заявления',
    voucher_appointments_voucherId: '№ Ваучера',
    voucher_appointments_childIIN: 'ИИН ребенка',
    voucher_appointments_childFIO: 'ФИО ребенка',
    voucher_appointments_childBirthday: 'Дата рождения',
    voucher_appointments_priorityCategory: 'Категория очередности',
    voucher_appointments_voucherIssueDate: 'Дата выдачи ваучера',
    voucher_appointments_voucherProlongDate: 'Срок дейс ваучера',
    voucher_appointments_voucherValidityPeriod: 'Срок действия ваучера',
    voucher_appointments_selectDO: 'Выбрать ДО',
    voucher_appointments_changeDO: 'Изменить ДО',
    voucher_appointments_transferDO: 'Зачислить в ДО',
    voucher_appointments_prolong: 'Продлить ваучер',
    voucher_appointments_enroll: 'Зачислить',
    voucher_appointments_DOName: 'Наименование ДО',
    voucher_appointment_actionsDownload: 'Скачать ваучер',

    voucher_applications_modalTitleProlong: 'Продление ваучера',
    voucher_applications_modalBodyProlong: 'Вы действительно хотите продлить ваучер?',

    voucher_appointments_errorLoad: 'Ошибка при загрузке данных',
    voucher_applications_error_prolongVoucher: 'Не удалось продлить ваучер'
  },
  kk: {
    voucher_appointments_subtitleDownload: 'Ваучердің шығу формасы',
    voucher_appointments_subtitle: 'Ваучерлер',
    voucher_appointments_modalYes: 'Иә',
    voucher_appointments_modalNo: 'Жоқ',
    voucher_appointments_requestFormId: 'Өтініш №',
    voucher_appointments_voucherId: 'Ваучер №',
    voucher_appointments_childIIN: 'Баланың ЖСН-і',
    voucher_appointments_childFIO: 'Баланың аты-жөні',
    voucher_appointments_childBirthday: 'Туған күні',
    voucher_appointments_priorityCategory: 'Кезектілік санаты',
    voucher_appointments_voucherIssueDate: 'Ваучер берілген мерзімі',
    voucher_appointments_voucherValidityPeriod: 'Ваучердың жарамдылық мерзімі',
    voucher_appointments_selectDO: 'МДҰ таңдау',
    voucher_appointments_changeDO: 'МДҰ өзгерту',
    voucher_appointments_transferDO: 'МДҰ-ға тіркеу',
    voucher_appointments_prolong: 'Ваучерді ұзарту',
    voucher_appointments_enroll: 'Қабылдау',
    voucher_appointments_DOName: 'Ұйым атауы',
    voucher_appointment_actionsDownload: 'Ваучерды жүктеу',

    voucher_applications_modalTitleProlong: 'Ваучерді ұзарту',
    voucher_applications_modalBodyProlong: 'Сіз ваучерді шынымен ұзартқыңыз келе ме?',

    voucher_appointments_errorLoad: 'Деректерді жүктеуде қателік орын алды',
    voucher_applications_error_prolongVoucher: 'Ваучерді ұзарту мүмкін болмады'
  }
});
